import Constant from '@/const';
import axios from 'axios';

const putPharmacyResetById = async id => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/patient/recipe/rollback/${id}`),
    );
    return response;
  } catch (error) {
    const variableError = error;
    throw variableError;
  }
};

export default putPharmacyResetById;
